import { RequestsStates } from "../../data/enums/requestsStates";
import { OperationRequestData } from "../../data/operationRequestData";
import { ActionStateEnum } from "../../models/enums/operStateEnum";
import { OperationModel } from "../../models/operations/operationModel";
import { inject, injectable } from "inversify";
import IAlertService from "../alert/IAlertService";
import { OperationsApi } from "../api/OperationsApi";
import { DiTokens } from "../diTokens";
import IErrorService from "../error/IErrorService";
import IOperationService from "./IOperationService";

/**Сервис проведения операций */
@injectable()
export default class BaseOperationService implements IOperationService {
  constructor(
    @inject(DiTokens.AlertService) public alertService: IAlertService,
    @inject(DiTokens.ErrorService) public errorService: IErrorService
  ) {}

  /**
   * Инициализация операции
   * @param args Данные для инициализации
   * */
  public async init(...args: any[]): Promise<OperationModel> {
    console.log("No implementation", args);
    return new OperationModel();
  }
  /**
   * Обработка assign
   * @param name Имя параметра
   */
  public async assign(
    name: string,
    model: OperationModel
  ): Promise<OperationModel> {
    console.log("No implementation", name, model);
    return new OperationModel();
  }

  /**
   * Обработка prepare
   */
  public async prepare(model: OperationModel): Promise<OperationModel> {
    try {
      model.ActionStateText = "";
      let ord: OperationRequestData = await model.createOperationRequest();
      ord = await OperationsApi.prepareOperationSendAsync(ord);
      model.setOperationFromRequest(ord, false);
      if (Object.keys(ord.PropertyErrors).length > 0) {
        model._actionState = ActionStateEnum.Init;
        model.propertyErrorsComes = true;
      } else {
        model.propertyErrorsComes = false;
        model.OperationId = ord.operationId;
        model._actionState = ActionStateEnum.Confirm;
        model._isNeedConfirm = ord.needConfirm;
        model.IsNeedInfoBeforeExecute =
          ord.needInfoBeforeExecute || !ord.needConfirm;
      }
    } catch (e) {
      model.ActionStateText = e.message;
      await this.errorService.errorHandler(e, false, true, "");
    }
    return model;
  }
  /**
   * Обработка execute
   */
  public async execute(model: OperationModel): Promise<OperationModel> {
    try {
      model.ActionStateText = "";
      let ord: OperationRequestData = await model.createOperationRequest();
      ord.verificationCode = model.VerifyCode;
      ord.operationId = model.OperationId;
      ord = await OperationsApi.executeOperationSendAsync(ord);
      model.RequestState = ord.requestState;
      model = await this.analyzeState(model, ord);
    } catch (e) {
      // if (
      //   e.message.indexOf("Пароль введен неверно") ||
      //   e.message.indexOf("Технические проблемы")
      // ) {
      //   model.TryCount--;
      // }
      model.ActionStateText = e.message;
      await this.errorService.errorHandler(e, false, true, "");
    }
    return model;
  }
  /**
   * Следующий шаг операции
   */
  public async nextStep(model: OperationModel): Promise<OperationModel> {
    if (model.checkProperties()) {
      if (model.IsInit) {
        model = await this.prepare(model);
        if (!model._isNeedConfirm && !model.ActionStateText) {
          model = await this.execute(model);
        }
      } else if (model.IsConfirm) model = await this.execute(model);
    }
    return model;
  }
  
  /**Предыдущий шаг */
  public async back(model: OperationModel): Promise<OperationModel> {
    if (model.IsConfirm && !model.ExecuteLoading && !model.PrepareLoading) {
      model._actionState = ActionStateEnum.Init;
      model.VerifyCode = "";
    }
    return model;
  }


  /**
   * Повторить код подтверждения
   * @param actionModel Данные операции
   */
  public async repeatConfirmCode(operId: number): Promise<void> {
    try {
      await OperationsApi.reCreateVerificationCodeAsync(operId);
    } catch (e) {
      await this.errorService.errorHandler(e, false, true, "");
    }
  }

  /**
   * Действия после проведения операции
   * @param args
   */
  public async afterExecute(...args: any[]): Promise<any> {
    console.log("Not implemented", args);
  }

  /**Вычисляем статус операции после выполнения */
  public async analyzeState(
    model: OperationModel,
    ord: OperationRequestData
  ): Promise<OperationModel> {
    model._actionState =
      ord.requestState == RequestsStates.Executed
        ? ActionStateEnum.Success
        : [3, 6, 7, 0].indexOf(ord.requestState as number) !== -1
        ? ActionStateEnum.Error
        : ActionStateEnum.Executing;
    model.ActionStateText = ord.requestStateDescription;
    return model;
  }
}
